import React from 'react'
import PropTypes from 'prop-types'
import styled, { useTheme } from 'styled-components'

const SvgWrap = styled.div`
  width: 56px;
  height: 56px;
  flex-shrink: 0;
`

const PacingRing = ({ pct, size = 56 }) => {
  const theme = useTheme()
  const s = theme.colors.semantic
  const clamped = Math.min(Math.max(pct, 0), 140)
  const r = size / 2 - 5
  const c = 2 * Math.PI * r
  const progress = Math.min(clamped / 140, 1) * c
  let color = s.success
  if (pct > 105) color = s.danger
  else if (pct > 95) color = s.warn

  return (
    <SvgWrap>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={s.surfaceSunken}
          strokeWidth="5"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={color}
          strokeWidth="5"
          strokeLinecap="round"
          strokeDasharray={`${progress} ${c}`}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
        <text
          x={size / 2}
          y={size / 2 + 4}
          textAnchor="middle"
          fontFamily={theme.fontFamily.sans.join(', ')}
          fontSize="13"
          fontWeight="700"
          fill={s.textPrimary}
        >
          {Math.round(pct)}%
        </text>
      </svg>
    </SvgWrap>
  )
}

PacingRing.propTypes = {
  pct: PropTypes.number.isRequired,
  size: PropTypes.number,
}

export default PacingRing
